// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ILockboxClaimRepaymentDto
 */
export interface ILockboxClaimRepaymentDto {
    /**
     * 
     * @type {number}
     * @memberof ILockboxClaimRepaymentDto
     */
    lockbox_id?: number;
    /**
     * 
     * @type {number}
     * @memberof ILockboxClaimRepaymentDto
     */
    employee_id?: number;
    /**
     * 
     * @type {number}
     * @memberof ILockboxClaimRepaymentDto
     */
    organization_id?: number;
    /**
     * 
     * @type {string}
     * @memberof ILockboxClaimRepaymentDto
     */
    organization_path?: string;
    /**
     * 
     * @type {number}
     * @memberof ILockboxClaimRepaymentDto
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof ILockboxClaimRepaymentDto
     */
    check_number?: string;
    /**
     * 
     * @type {string}
     * @memberof ILockboxClaimRepaymentDto
     */
    document_path?: string;
    /**
     * 
     * @type {string}
     * @memberof ILockboxClaimRepaymentDto
     */
    receive_date?: string;
}

/**
 * Check if a given object implements the ILockboxClaimRepaymentDto interface.
 */
export function instanceOfILockboxClaimRepaymentDto(value: object): value is ILockboxClaimRepaymentDto {
    return true;
}

export function ILockboxClaimRepaymentDtoFromJSON(json: any): ILockboxClaimRepaymentDto {
    return ILockboxClaimRepaymentDtoFromJSONTyped(json, false);
}

export function ILockboxClaimRepaymentDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ILockboxClaimRepaymentDto {
    if (json == null) {
        return json;
    }
    return {
        
        'lockbox_id': json['lockbox_id'] == null ? undefined : json['lockbox_id'],
        'employee_id': json['employee_id'] == null ? undefined : json['employee_id'],
        'organization_id': json['organization_id'] == null ? undefined : json['organization_id'],
        'organization_path': json['organization_path'] == null ? undefined : json['organization_path'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'check_number': json['check_number'] == null ? undefined : json['check_number'],
        'document_path': json['document_path'] == null ? undefined : json['document_path'],
        'receive_date': json['receive_date'] == null ? undefined : json['receive_date'],
    };
}

export function ILockboxClaimRepaymentDtoToJSON(json: any): ILockboxClaimRepaymentDto {
    return ILockboxClaimRepaymentDtoToJSONTyped(json, false);
}

export function ILockboxClaimRepaymentDtoToJSONTyped(value?: ILockboxClaimRepaymentDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'lockbox_id': value['lockbox_id'],
        'employee_id': value['employee_id'],
        'organization_id': value['organization_id'],
        'organization_path': value['organization_path'],
        'amount': value['amount'],
        'check_number': value['check_number'],
        'document_path': value['document_path'],
        'receive_date': value['receive_date'],
    };
}

